export abstract class CookieBanner {
  static isEnabled(): boolean {
    if (window.cmp && window.cmp.getConsentForGV) {
      return window.cmp.getConsentForGV("OTTOT") || window.cmp.getConsentForGV("OTTON") || false;
    }
    return false;
  }
}
